export function getReportsForExport() {
    return {
        "data": [
            {
                "Employee": {
                    "_id": "64e6deaf1a3aff002d9d7977",
                    "displayName": "Renie Ver Basilio",
                    "firstName": "Renie Ver",
                    "lastName": "Basilio"
                },
                "date": "2026-05-03",
                "reports": [],
                "count": 5
            },
            {
                "Employee": {
                    "_id": "6198e7cc9ab4790042035b54",
                    "displayName": "Abby Domacena",
                    "firstName": "Abby",
                    "lastName": "Domacena"
                },
                "date": "2026-05-03",
                "reports": [],
                "count": 5
            },
        ],
        "l": 5
    }
}

//user/limited/recordsV3
export function getRecordsV3() {
    return [
        {
            "_id": "69f7e3101c571c006d1e5eff",
            "record": [
                {
                    "dateTime": "2026-05-04T08:06:40.014Z",
                    "status": "time-in",
                    "month": 5,
                    "day": 4,
                    "year": 2026,
                    "time": 1777853200051,
                    "date": "2026-05-04T00:00:00.000Z",
                    "location": {
                        "latitude": 14.6038679,
                        "longitude": 120.9890411
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "6198e7cc9ab4790042035b54",
            "date": "2026-05-04T00:00:00.000Z",
            "status": "time-in",
            "createdAt": "2026-05-04T08:06:40.014Z",
            "updatedAt": "2026-05-04T08:06:40.014Z",
            "__v": 0,
            "email": "a.domacena@yahoo.com"
        },
        {
            "_id": "69f7e1ba1c571c006d1e1f79",
            "record": [
                {
                    "dateTime": "2026-05-04T08:00:57.981Z",
                    "status": "time-in",
                    "month": 5,
                    "day": 4,
                    "year": 2026,
                    "time": 1777852858014,
                    "date": "2026-05-04T00:00:00.000Z",
                    "location": {
                        "latitude": 14.336561020956697,
                        "longitude": 121.06307903149168
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "64e6deaf1a3aff002d9d7977",
            "date": "2026-05-04T00:00:00.000Z",
            "status": "time-in",
            "createdAt": "2026-05-04T08:00:57.981Z",
            "updatedAt": "2026-05-04T08:00:57.981Z",
            "__v": 0,
            "email": "rverski@gmail.com"
        },
        {
            "_id": "69f7e09f1c571c006d1dd3d7",
            "record": [
                {
                    "dateTime": "2026-05-04T07:56:15.008Z",
                    "status": "time-in",
                    "month": 5,
                    "day": 4,
                    "year": 2026,
                    "time": 1777852575041,
                    "date": "2026-05-04T00:00:00.000Z",
                    "location": {
                        "latitude": 7.055803221114008,
                        "longitude": 125.5515623731645
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "654b5265b38c77002d9cfe5b",
            "date": "2026-05-04T00:00:00.000Z",
            "status": "time-in",
            "createdAt": "2026-05-04T07:56:15.008Z",
            "updatedAt": "2026-05-04T07:56:15.008Z",
            "__v": 0,
            "email": "anthonyjoshua.sparkle@gmail.com"
        },
        {
            "_id": "69f7db0e1c571c006d1cfbf7",
            "record": [
                {
                    "dateTime": "2026-05-04T07:32:29.797Z",
                    "status": "time-in",
                    "month": 5,
                    "day": 4,
                    "year": 2026,
                    "time": 1777851149831,
                    "date": "2026-05-04T00:00:00.000Z",
                    "location": {
                        "latitude": 13.7907083,
                        "longitude": 121.0072283
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61725afdcf9f680042b21d21",
            "date": "2026-05-04T00:00:00.000Z",
            "status": "time-in",
            "createdAt": "2026-05-04T07:32:29.797Z",
            "updatedAt": "2026-05-04T07:32:29.797Z",
            "__v": 0,
            "email": "dmcilagan@gmail.com"
        },
        {
            "_id": "69f7dad11c571c006d1cf34b",
            "record": [
                {
                    "dateTime": "2026-05-04T07:31:29.451Z",
                    "status": "time-in",
                    "month": 5,
                    "day": 4,
                    "year": 2026,
                    "time": 1777851089484,
                    "date": "2026-05-04T00:00:00.000Z",
                    "location": {
                        "latitude": 15.7169613,
                        "longitude": 121.5239078
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61442a17a6566a001623bf20",
            "date": "2026-05-04T00:00:00.000Z",
            "status": "time-in",
            "createdAt": "2026-05-04T07:31:29.451Z",
            "updatedAt": "2026-05-04T07:31:29.451Z",
            "__v": 0,
            "email": "jeffreypareja25@gmail.com"
        },
        {
            "_id": "69f2ac0e1c571c006d8ec837",
            "record": [
                {
                    "dateTime": "2026-04-30T09:10:37.812Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777511437850,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.6037885,
                        "longitude": 120.9888213
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-05-04T08:06:23.567Z",
                    "status": "time-out",
                    "month": 5,
                    "day": 4,
                    "year": 2026,
                    "time": 1777853183604,
                    "date": "2026-05-04T00:00:00.000Z",
                    "location": {
                        "latitude": 14.6038274,
                        "longitude": 120.9888749
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "6198e7cc9ab4790042035b54",
            "date": "2026-04-30T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-30T09:10:37.812Z",
            "updatedAt": "2026-05-04T00:06:23.952Z",
            "__v": 0,
            "email": "a.domacena@yahoo.com"
        },
        {
            "_id": "69f29a0c1c571c006d8bada7",
            "record": [
                {
                    "dateTime": "2026-04-30T07:53:48.408Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777506828443,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 7.055772368846885,
                        "longitude": 125.55155204064407
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-30T18:46:08.552Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777545968589,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 7.05575137097963,
                        "longitude": 125.55156975080408
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "654b5265b38c77002d9cfe5b",
            "date": "2026-04-30T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-30T07:53:48.408Z",
            "updatedAt": "2026-04-30T10:46:08.930Z",
            "__v": 0,
            "email": "anthonyjoshua.sparkle@gmail.com"
        },
        {
            "_id": "69f298821c571c006d8b47ad",
            "record": [
                {
                    "dateTime": "2026-04-30T07:47:14.272Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777506434307,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.336561020956697,
                        "longitude": 121.06307903149168
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-30T17:25:03.895Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777541103970,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.2818161,
                        "longitude": 121.0941735
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-30T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-30T07:47:14.272Z",
            "updatedAt": "2026-04-30T09:25:04.232Z",
            "__v": 0,
            "email": "rverski@gmail.com"
        },
        {
            "_id": "69f290a71c571c006d8a9a22",
            "record": [
                {
                    "dateTime": "2026-04-30T07:13:42.290Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777504422325,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.877886689058291,
                        "longitude": 121.047653389409
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-30T17:07:55.840Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777540075877,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.877846193002936,
                        "longitude": 121.04752381758179
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61442a17a6566a001623bf20",
            "date": "2026-04-30T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-30T07:13:42.290Z",
            "updatedAt": "2026-04-30T09:07:56.239Z",
            "__v": 0,
            "email": "jeffreypareja25@gmail.com"
        },
        {
            "_id": "69f286781c571c006d89744d",
            "record": [
                {
                    "dateTime": "2026-04-30T06:30:16.520Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777501816561,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.5134391,
                        "longitude": 120.9799187
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-30T18:26:47.738Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777544807777,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 13.7864144,
                        "longitude": 121.0301085
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61725afdcf9f680042b21d21",
            "date": "2026-04-30T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-30T06:30:16.520Z",
            "updatedAt": "2026-04-30T10:26:48.141Z",
            "__v": 0,
            "email": "dmcilagan@gmail.com"
        },
        {
            "_id": "69f152491c571c006d66ee9a",
            "record": [
                {
                    "dateTime": "2026-04-29T08:35:21.108Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777422921145,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 14.6038884,
                        "longitude": 120.9891357
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-30T07:45:19.467Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 30,
                    "year": 2026,
                    "time": 1777506319554,
                    "date": "2026-04-30T00:00:00.000Z",
                    "location": {
                        "latitude": 14.5633594,
                        "longitude": 121.0019657
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "6198e7cc9ab4790042035b54",
            "date": "2026-04-29T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-29T08:35:21.108Z",
            "updatedAt": "2026-04-29T23:45:19.920Z",
            "__v": 0,
            "email": "a.domacena@yahoo.com"
        },
        {
            "_id": "69f148af1c571c006d6524fa",
            "record": [
                {
                    "dateTime": "2026-04-29T07:54:22.881Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777420462913,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 7.055702754300039,
                        "longitude": 125.55154764642624
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-29T17:52:14.985Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777456335024,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 7.055720476758936,
                        "longitude": 125.55154184037386
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "654b5265b38c77002d9cfe5b",
            "date": "2026-04-29T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-29T07:54:22.881Z",
            "updatedAt": "2026-04-29T09:52:15.389Z",
            "__v": 0,
            "email": "anthonyjoshua.sparkle@gmail.com"
        },
        {
            "_id": "69f148461c571c006d6506cd",
            "record": [
                {
                    "dateTime": "2026-04-29T07:52:38.028Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777420358064,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 14.336561020956697,
                        "longitude": 121.06307903149168
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-29T17:46:24.891Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777455984928,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 14.336561020956697,
                        "longitude": 121.06307903149168
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-29T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-29T07:52:38.028Z",
            "updatedAt": "2026-04-29T09:46:25.265Z",
            "__v": 0,
            "email": "rverski@gmail.com"
        },
        {
            "_id": "69f145f91c571c006d645735",
            "record": [
                {
                    "dateTime": "2026-04-29T07:42:48.789Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777419768841,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 14.8778834,
                        "longitude": 121.0476995
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-29T17:48:44.695Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777456124728,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 14.877760660468141,
                        "longitude": 121.04750145164572
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61442a17a6566a001623bf20",
            "date": "2026-04-29T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-29T07:42:48.789Z",
            "updatedAt": "2026-04-29T09:48:45.082Z",
            "__v": 0,
            "email": "jeffreypareja25@gmail.com"
        },
        {
            "_id": "69f1353e1c571c006d62c066",
            "record": [
                {
                    "dateTime": "2026-04-29T06:31:25.719Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777415485752,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 13.78633,
                        "longitude": 121.0300643
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-29T17:58:15.036Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 29,
                    "year": 2026,
                    "time": 1777456695073,
                    "date": "2026-04-29T00:00:00.000Z",
                    "location": {
                        "latitude": 14.5130072,
                        "longitude": 120.9795512
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61725afdcf9f680042b21d21",
            "date": "2026-04-29T00:00:00.000Z",
            "status": "time-out",
            "createdAt": "2026-04-29T06:31:25.719Z",
            "updatedAt": "2026-04-29T09:58:15.676Z",
            "__v": 0,
            "email": "dmcilagan@gmail.com"
        }
    ]
}